import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {AuthService} from '@app/core/services/auth.service';
import {SidenavService} from '@app/core/services/sidenave-service';
import {UserProfileService} from '@services/user-profile.service';
import {AlertsService} from '@app/core/services/alerts.service';
import {formatDate} from '@angular/common';
import {ContextService} from '@services/context.service';
import {ConfirmationService} from 'primeng/api';
import {DymoLabelUtility} from '@shared/utilities/dymo-label.utility';
import {ContextModel, tenantConfigsModel} from '@app/models/context.model';
import {TenantConfigService} from '@services/tenant-config.service';
import {RosterService} from '@services/roster.service';
import {PrimeTableFilterModel} from '@app/models/table-filter.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DataPerspectiveDropdownComponent} from '../data-perspective-dropdown/data-perspective-dropdown.component';
import {SharedImports} from '@shared/shared-imports';
import {StyleClassModule} from 'primeng/styleclass';
import {UserAccountService} from '@services/user-account.service';

declare const Beacon: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {
    '(window:click)': 'onWindowClick()'
  },
  imports: [SharedImports, DataPerspectiveDropdownComponent, StyleClassModule]
})

export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  isSuperUser: boolean = false;
  dataPerspectiveOpen: boolean = false;
  menuOpen: boolean = false;
  alertCount: number = 0;
  alertsOpen: boolean = false;
  @Output() MenuSelect = new EventEmitter<any>();
  @Output() MenuViewSelect = new EventEmitter<any>();
  menu: string = 'top';
  public showBurger: boolean = false;
  personPhotoSrc: string = '../../../../assets/images/user@2x.png';
  personName: string;
  loggedIn: string;
  showMenuViewDD: boolean = false;
  showWorkingAs: boolean;
  selectedWorkingAs: string;
  placeholder = 'Member #, Name, Email, Phone';
  buttonIcon = 'Aa';
  isNameSearch: boolean;
  searchData: string;
  suggestions: any[];
  selectedMember;
  searching: boolean;
  tenantContext: string = 'membership';
  hasMultipleContext: boolean;
  showMobileSearch: boolean = false;
  isMobile: boolean = false;
  currentFilter = new PrimeTableFilterModel();
  @Input() showMenuSelect: boolean;
  @Input() parentShowBurger: boolean;
  getListRequest;
  notProd: boolean = false;
  isAdministrator: boolean = false;

  options = [
    {
      description: 'IAFF',
    }, {
      description: 'IMTEF',
    }, {
      description: 'IUPAT',
    }, {
      description: 'OPCMIA633',
    }, {
      description: 'OPEIU50HNA',
    }, {
      description: 'OPEIU109',
    }, {
      description: 'PIPSC',
    }, {
      description: 'UA486',
    }, {
      description: 'UNSU',
    }, {
      description: 'WEA',
    }
  ];
  pipe: any;
  @ViewChild('autocompleteDiv', {static: false}) myAutoComplete?: ElementRef;
  private ngUnsubscribe = new Subject();

  constructor(private authService: AuthService, private sidenavService: SidenavService, private userAccountService: UserAccountService,
              private alertService: AlertsService, private userProfileService: UserProfileService,
              private router: Router, private contextService: ContextService, private dialogService: DialogService,
              private confirmationService: ConfirmationService, private dymoLabelUtility: DymoLabelUtility,
              private tenantConfigService: TenantConfigService, private rosterService: RosterService,
              private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.isAdministrator = this.contextService.contextObject.SuperUser;
    this.isMobile = this.contextService.contextObject.isMobile;
    // console.log(this.isMobile);
    // console.log(this.isAdministrator);
    this.router.events.subscribe({
      next: (event: any) => {
        if (event instanceof NavigationEnd) {
          this.getAlerts();
        }
      }
    });
    if (sessionStorage.getItem('workingAs') === 'undefined' || sessionStorage.getItem('workingAs') === null) {
      sessionStorage.setItem('workingAs', this.contextService.contextObject.tenantName);
    }
    // console.log('working as = ' + sessionStorage.getItem('workingAs'));
    this.selectedWorkingAs = sessionStorage.getItem('workingAs');
    const context = this.contextService.contextObject;
    if (sessionStorage.getItem('env') === 'dev') {
      this.showWorkingAs = true;
    }
    this.isSuperUser = false;
    if (context && context !== 'null') {
      if (context.SuperUser) {
        this.isSuperUser = context.SuperUser;
      }
      this.getProfilePhoto(context.PersonId);
      this.personName = context.PersonName;
    } else {
      this.personPhotoSrc = '../../../../assets/images/user@2x.png';
      this.personName = '';
    }

    const format = 'MM/dd/yyyy h:mm:ss a';
    const myDate = this.contextService.contextObject.loggedIn;
    const locale = 'en-US';
    this.loggedIn = formatDate(myDate, format, locale);

    // pre-load tenant configs
    this.tenantConfigService.getTenantConfigAll()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: tenantConfigsModel[]) => {
          const context1: ContextModel = this.contextService.contextObject;
          context1.tenantConfigs = res;
          this.contextService.contextObject = context1;
        }, error: () => {
          // do nothing
        }
      });

    // pre-load dymo
    this.dymoLabelUtility.isDymoInstalled().then(() => {
      this.dymoLabelUtility.isDymoPrinterInstalled();
    }).catch(() => {
      // do nothing
    });

    this.currentFilter.sortOrder = 1;
    this.currentFilter.first = 0;
    this.currentFilter.filters = {};

    if (this.contextService.contextObject.Contexts?.length === 1 && this.contextService.contextObject.Contexts.includes('TRAINING')) {
      this.tenantContext = 'training';
      this.hasMultipleContext = false;
    } else if (this.contextService.contextObject.Contexts?.length === 1 && this.contextService.contextObject.Contexts.includes('MEMBERSHIP')) {
      this.tenantContext = 'membership';
      this.hasMultipleContext = false;
    } else {
      this.hasMultipleContext = true;
    }
    if (this.contextService.contextObject.tenantName !== 'IUPAT') {
      this.getHelpScoutData();
    }
  }

  getHelpScoutData() {
    this.userAccountService.getUserHelpScoutData()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (res.BeaconID !== 'BEACON_ID') {
            Beacon('init', {
              beaconId: res.BeaconID,
            });
          } else {
            Beacon('init', {
              beaconId: '2ceafbcc-5ebc-482c-9e41-ce6ff43df0bd',
            });
          }
          Beacon('identify', {
            name: this.personName,
            email: this.contextService.contextObject.UserName,
            url: window.location.host,
            jobTitle: res.JobTitle,
            company: res.CompanyName,
            Organization: res.OrganizationAbbreviation,
            phoneNumber: res.PhoneNumber
          });
        }, error: (e) => {
        }
      });
  }

  // toggleSearch() {
  //   this.isNameSearch = !this.isNameSearch;
  //   this.selectedMember = null;
  //   if (this.isNameSearch && this.tenantContext === 'membership') {
  //     this.placeholder = 'Member Name';
  //     this.buttonIcon = '#';
  //   } else if (this.tenantContext === 'training' && this.isNameSearch) {
  //     this.placeholder = 'Student Name';
  //     this.buttonIcon = '#';
  //   } else if (this.tenantContext === 'training' && !this.isNameSearch) {
  //     this.placeholder = 'Student #';
  //     this.buttonIcon = 'Aa';
  //   } else if (this.tenantContext === 'membership' && !this.isNameSearch) {
  //     this.placeholder = 'Member #';
  //     this.buttonIcon = 'Aa';
  //   }
  // }

  // toggleContext() {
  //   this.isNameSearch = false;
  //   if (this.tenantContext === 'membership') {
  //     this.tenantContext = 'training';
  //     this.placeholder = 'Student #';
  //   } else {
  //     this.tenantContext = 'membership';
  //     this.placeholder = 'Member #';
  //   }
  //   this.buttonIcon = 'Aa';
  // }

  searchMembers(event: any) {
    this.searching = true;
    const tempPayload = {
      Input: event.query
    };
    if (this.getListRequest) {
      this.getListRequest.unsubscribe();
    }
    if (event.query?.length >= 3) {
      this.getListRequest = this.rosterService.quickSearch(tempPayload)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res) => {
            this.suggestions = res;
            this.searching = false;
          }, error: () => {
            // do nothing
          }
        });
    }
  }

  getMember(member) {
    this.router.navigateByUrl('profiles/edit/' + member.PersonId + '?selRosterId=' + member.PersonId);
    setTimeout(() => {
      this.selectedMember = '';
    }, 400);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  ngAfterViewInit(): void {
    //check for alert updates every 30 minutes
    setInterval(() => {
      if (!this.router.url.includes('login')) {
        this.getAlerts();
      }
    }, 5*60000);


    // use commented out code for testing token expire/renew
    //  const tempContext:ContextModel = this.contextService.contextObject;
    //  tempContext.accessToken = tempContext.accessToken + '1';
    //  this.contextService.contextObject = tempContext;


    if (this.notProd && this.isAdministrator) {
      this.myAutoComplete.nativeElement.children[0].children[0].setAttribute('data-lpignore', 'true');
      this.renderer.addClass(this.myAutoComplete.nativeElement.children[0].children[0], 'keeper-ignore');
      this.myAutoComplete.nativeElement.children[0].children[0].setAttribute('data-keeper-ignore', 'true');
    }
    this.showBurger = this.parentShowBurger;
  }

  getAlerts(): void {
    this.alertService.getAlerts().pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res) => {
        this.alertCount = res.Count;
      }
    });
  }

  getProfilePhoto(personId: number): void {
    this.userProfileService.getUserProfilePhoto(personId)
      .pipe(take(1)).subscribe({
      next: (res) => {
        if (res.length === 4) {
          this.personPhotoSrc = res[1].Url;
        } else {
          this.personPhotoSrc = '../../../../assets/images/user@2x.png';
        }
      }, error: () => {
        this.personPhotoSrc = '../../../../assets/images/user@2x.png';
      }
    });
  }

  toggleMenu($event): void {
    $event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  toggleAlertMenu(): void {
    this.sidenavService.updateAlertSideBar();
  }

  onWindowClick(): void {
    // this.dataPerspectiveOpen = false;
    this.menuOpen = false;
    this.alertsOpen = false;
  }

  logOut(): void {
    this.authService.logout();
  }

  openCloseNav(): void {
    this.sidenavService.updateMenuSideBar();
  }

  // menuView(): void {
  //   this.showMenuViewDD = !this.showMenuViewDD;
  // }

  menuSelected(): void {
    if (this.menu === 'side') {
      this.menu = 'top';
      this.parentShowBurger = false;

    } else {
      this.menu = 'side';
      this.parentShowBurger = true;
    }
    this.openCloseNav();
    this.MenuSelect.emit(this.menu);
  }

  ShowDropDown(): void {
    this.dataPerspectiveOpen = false;
  }

  openDataPerspective($event): void {
    // $event.stopPropagation();
    this.dataPerspectiveOpen = !this.dataPerspectiveOpen;
  }

  goToDashboard() {
    if (this.contextService.contextObject.Administrator) {
      this.router.navigateByUrl('dashboard');
    } else {
      this.router.navigateByUrl('dashboard');
    }
  }

  resetWarning(): void {
    this.confirmationService.close();
  }

  processClient(client): void {
    sessionStorage.setItem('workingAs', client.value);
    this.selectedWorkingAs = client;
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }

  // contactSupport() {
  //   const ref = this.dialogService.open(ContactSupportDialogComponent, {
  //     header: 'Contact Support',
  //     width: '60%',
  //     height: '400',
  //     modal: true,

  //     closable: true,
  //     draggable: false,
  //   });
  // }
}
